// saga.js
import { call, put, takeEvery } from 'redux-saga/effects'
import axios, { Axios } from 'axios' // Make sure to replace this with your axiosInstance if you have one
import {
  fetchFeedbacksSuccess,
  fetchFeedbacksFailure,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import { FETCH_FEEDBACKS_REQUEST } from './actionTypes'

// API call to fetch feedbacks
const fetchFeedbacksAPI = () => axiosInstance.get('', { params: { sp: "usp_GetFeedback" } })

// Worker saga to handle the API call
function* fetchFeedbacks() {
  try {
    const response = yield call(fetchFeedbacksAPI)
    yield put(fetchFeedbacksSuccess(response.data))
  } catch (error) {
    yield put(fetchFeedbacksFailure(error.message))
  }
}

// Watcher saga to listen for FETCH_FEEDBACKS_REQUEST action
export default function* feedbackSaga() {
  yield takeEvery(FETCH_FEEDBACKS_REQUEST, fetchFeedbacks)
}
